import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { Grid, Paper, Slide } from "@material-ui/core"

import {
	HouseIcon,
	MenuIcon,
	ChevronLeftIcon,
	XIcon as CloseIcon
} from "lucide-react"

import useStyles from "@/@integrations/Whatsapp/components/Menu/MobileMenuBar/styles"
import { ChannelType } from "@/protocols/channel"
import { MenuCategory, MenuItem, useDashboardMenuData } from "@/hooks/useDashboardMenuData"

type MobileMenuBarProps = {
	hiddenTabs?: boolean
	menuType?: ChannelType
}

const MobileMenuBar: React.FC<MobileMenuBarProps> = ({ hiddenTabs, menuType }) => {
	const classes = useStyles()
	const history = useHistory()

	const menuData = useDashboardMenuData(menuType, classes, hiddenTabs)

	const {
		defaultMenuCategories,
		bottomMenuCategories
	} = menuData

	const [openMenu, setOpenMenu] = useState(false)

	const [openedCategoryId, setOpenedCategoryId] = useState<string | null>(null)

	const navigate = (item: MenuItem) => {
		if (item.isExternal && item.to) {
			window.open(item.to, "_blank")
		} else if (item.to) {
			history.push(item.to)
		}
		setOpenMenu(false)
	}

	const handleNavigationClick = (category: MenuCategory) => {
		if (category.items) {
			setOpenedCategoryId(category.id)
		} else {
			navigate(category)
		}
	}

	const redirectToHome = () => {
		history.push("/admin/dashboard")
	}

	const openedCategory = [
		...defaultMenuCategories,
		...bottomMenuCategories
	].find((category) => category.id === openedCategoryId)

	return (
		<>
			<Paper elevation={8} className={classes.footer}>
				<Grid container className={classes.menuWrapper}>
					<Grid item className={classes.menuItem} onClick={redirectToHome}>
						<HouseIcon className={classes.icon} />
						<span className={classes.label}>Home</span>
					</Grid>

					<Grid item className={classes.menuItem} onClick={() => setOpenMenu(true)}>
						<MenuIcon className={classes.icon} />
						<span className={classes.label}>Menu</span>
					</Grid>
				</Grid>
			</Paper>

			<Slide direction="up" in={openMenu} mountOnEnter unmountOnExit>
				<Grid className={classes.fullScreenMenu}>

					<Grid className={classes.menuHeader}>
						{openedCategoryId ? (
							<Grid className={classes.backBtn} onClick={() => setOpenedCategoryId(null)}>
								<ChevronLeftIcon size={22} /> Voltar
							</Grid>
						) : (
							<Grid className={classes.closeBtn} onClick={() => setOpenMenu(false)}>
								<CloseIcon/>
							</Grid>
						)}
					</Grid>

					<Grid className={classes.menuContent}>
						{!openedCategoryId ? (
							<>
								{defaultMenuCategories.map((category) => (
									<Grid
										key={category.id}
										className={classes.category}
										onClick={() => handleNavigationClick(category)}
									>
										{category.icon}
										<span className={classes.categoryLabel}>{category.label}</span>
									</Grid>
								))}

								{bottomMenuCategories.map((category) => (
									<Grid
										key={category.id}
										className={classes.category}
										onClick={() => handleNavigationClick(category)}
									>
										{category.icon}
										<span className={classes.categoryLabel}>{category.label}</span>
									</Grid>
								))}
							</>
						) : (
							<>
								{openedCategory?.items?.map((item, index) => (
									<Grid
										key={index}
										className={classes.subItem}
										onClick={() => {
											if (item.isExternal && item.to) {
												window.open(item.to, "_blank")
											} else if (item.to) {
												history.push(item.to)
											}
											if (item.onClick) item.onClick()
											setOpenMenu(false)
										}}
									>
										{item.icon}
										<span className={classes.subItemLabel}>{item.label}</span>
									</Grid>
								))}
							</>
						)}
					</Grid>
				</Grid>
			</Slide>
		</>
	)
}

export default MobileMenuBar
